/* eslint-disable no-console */

import { register } from "register-service-worker";

/**
 * @param {Vue} eventBus
 * @returns {Promise<void>}
 * @emits appUpdated
 * @emits queueCountUpdated
 * @emits authenticated
 * @emits unauthenticated
 */
export default async eventBus => {
  register(`${process.env.BASE_URL}service-worker.js`, {
    async ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
      navigator.serviceWorker.onmessage = event => {
        if (event.data) {
          switch (event.data.type) {
            case "QUEUE_COUNT":
              eventBus.$emit("queueCountUpdated", event.data.size);
              break;
            case "AUTHENTICATED":
              eventBus.$emit("authenticated", event.data.user);
              break;
            case "UNAUTHENTICATED":
              eventBus.$emit("unauthenticated");
              break;
            default:
          }
        }
      };
      navigator.serviceWorker.controller?.postMessage({
        type: "CHECK_AUTH"
      });
      navigator.serviceWorker.controller?.postMessage({
        type: "GET_QUEUE_COUNT"
      });
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      if (process.env.NODE_ENV === "production") {
        console.log("New content is downloading.");
      }
    },
    updated() {
      if (process.env.NODE_ENV === "production") {
        console.log("New content is available; please refresh.");
        eventBus.$emit("appUpdated");
      }
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
};
